import GenericOrdersListing from "@Pages/OrderListing/GenericOrdersListing.js";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import ChatPopup from "@Pages/GenericOrderChat/ChatPopup.jsx";

function TreasuryCoordinatorPendingOrder() {
  return (
    <GenericOrdersListing
      title="Pending Orders"
      isReleased={false}
      isCanceled={false}
      readOnly={true}
      icon={AssignmentRoundedIcon}
      ChatPopup={ChatPopup}
      showAddOrder={false}
      allOrders = {true}
    />
  );
}

export default TreasuryCoordinatorPendingOrder;
